module.exports = __webpack_public_path__ + "img/rentycloudy.526235ef.png";